<template>
  <SfModal
    v-if="showModal"
    class-name="sf-modal sf-modal-m"
    @close="closeModal"
  >
    <template #title>
      {{ title }}
    </template>
    <template #body>
      <div
        class="wistia_responsive_padding"
        style="padding: 56.25% 0 0; position: relative"
      >
        <div
          class="wistia_responsive_wrapper"
          style="height: 100%; left: 0; position: absolute; top: 0; width: 100%"
        >
          <div
            :class="wistiaClass"
            style="height: 100%; position: relative; width: 100%"
          >
            <div
              class="wistia_swatch"
              style="
                height: 100%;
                left: 0;
                opacity: 0;
                overflow: hidden;
                position: absolute;
                top: 0;
                transition: opacity 200ms;
                width: 100%;
              "
            >
              <img
                :src="wistiaThumbnailUrl"
                style="
                  filter: blur(5px);
                  height: 100%;
                  object-fit: contain;
                  width: 100%;
                "
                alt=""
                aria-hidden="true"
                onload="this.parentNode.style.opacity=1;"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import { SfModal } from '@app/shared/vue/components/sf-modal'

export default {
  name: 'WistiaVideoModal',
  components: { SfModal },
  data() {
    return {
      showModal: true,
      title: '',
      videoId: '',
    }
  },
  computed: {
    wistiaClass() {
      return `wistia_embed wistia_async_${this.videoId} videoFoam=true`
    },
    wistiaThumbnailUrl() {
      return `https://fast.wistia.com/embed/medias/${this.videoId}/swatch`
    },
  },
  methods: {
    openModal({ title, videoId }) {
      this.title = title
      this.videoId = videoId
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
